export const DASHBOARD_TILE_IDS = [
  'opportunities-funnel',
  'workshop-overview',
  'vehicle-warehouse',
  'support',
  'latest-vehicles',
  'my-tasks',
  'notifications',
  'latest-business-cases',
  'latest-interests',
  'recommended-actions',
] as const;
